

































import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

import { ScopesTypes } from '@/Types/ScopesTypes';
import Sidebar from '../../components/Sidebar/Sidebar.vue';
import {
  ActionTypes as ActionTypesQueue,
  FetchSlotsForQueueData,
  GetterTypes as GetterTypesQueue
} from '../../store/queues/types';
import QueueList from '../../components/QueueList/QueueList.vue';
import Queue from '../../models/Queue';

import './UserQueuesPanel.scss';

const queueNamespace: string = 'queue';

@Component({
  components: {
    Sidebar,
    QueueList
  }
})
export default class UserQueuesPanel extends Vue {
  @Action(ActionTypesQueue.FETCH_QUEUES, { namespace: queueNamespace }) fetchQueues!: () => Promise<void>;
  @Action(ActionTypesQueue.FETCH_SLOTS_FOR_QUEUE, { namespace: queueNamespace }) fetchQueueSlots!: (
    payload: FetchSlotsForQueueData
  ) => Promise<Queue>;
  @Getter(GetterTypesQueue.GET_QUEUE, { namespace: queueNamespace }) queue!: Queue;
  @Getter(GetterTypesQueue.GET_IS_LOADING, { namespace: queueNamespace }) isQueueActionLoading!: boolean;

  private queues: Queue[] = [] as Queue[];

  private mounted() {
    this.getQueues();
  }

  private getMinimalDeltaTimeString(): string {
    if (this.queue) {
      if (this.queue.minimalSlotAvailabilityDeltaTime) {
        if (this.queue.minimalSlotAvailabilityDeltaTime <= 1) {
          return `${this.queue.minimalSlotAvailabilityDeltaTime} minutę`;
        }

        if (this.queue.minimalSlotAvailabilityDeltaTime <= 4) {
          return `${this.queue.minimalSlotAvailabilityDeltaTime} minuty`;
        }

        if (this.queue.minimalSlotAvailabilityDeltaTime <= 59) {
          return `${this.queue.minimalSlotAvailabilityDeltaTime} minut`;
        }

        const hours = this.queue.minimalSlotAvailabilityDeltaTime / 60;

        if (this.queue.minimalSlotAvailabilityDeltaTime <= 1) {
          return `${hours} godzinę`;
        }

        if (this.queue.minimalSlotAvailabilityDeltaTime <= 4) {
          return `${hours} godziny`;
        }

        if (this.queue.minimalSlotAvailabilityDeltaTime <= 23) {
          return `${hours} godzin`;
        }

        const days = hours / 24;

        if (days <= 1) {
          return `${days} dzień`;
        }

        return `${days} dni`;
      }
    }

    return '';
  }

  private async getQueues(): Promise<void> {
    try {
      await this.fetchQueues();
    } catch (err: unknown) {
      if (process.env.APP_DEBUG === true) {
        console.error(err);
      }
    }
  }

  private async refresh(): Promise<void> {
    if (this.queue && this.queue.uuid) {
      try {
        await this.fetchQueueSlots({ queueUuid: this.queue.uuid, scope: ScopesTypes.USER });
      } catch (err: unknown) {
        console.log(err);
      }
    }
  }
}
